"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = exports.ModalContainer = void 0;
var react_1 = __importStar(require("react"));
var i18n_1 = require("../../i18n");
var styles_1 = require("../../styles");
var Button_1 = require("../Button");
var Icon_1 = require("../Icon");
var Tooltip_1 = require("../Tooltip");
exports.ModalContainer = react_1.forwardRef(function (props, ref) {
    var style = props.style, onClose = props.onClose, hasCloseIcon = props.hasCloseIcon, children = props.children, rest = __rest(props, ["style", "onClose", "hasCloseIcon", "children"]);
    var _a = styles_1.useStyles(exports.styles), classes = _a.classes, css = _a.css;
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement("div", __assign({ role: 'dialog', "aria-modal": 'true', ref: ref, className: css(classes.wrapper, style) }, rest),
        hasCloseIcon && (react_1.default.createElement(Tooltip_1.Tooltip, { text: locale.modal.close },
            react_1.default.createElement(Button_1.Button, { "aria-label": locale.modal.close, size: 'small', skin: 'ghost', style: classes.closeButton, onClick: onClose },
                react_1.default.createElement(Icon_1.Icon, { icon: 'timesDefault' })))),
        children));
});
exports.ModalContainer.defaultProps = {
    hasCloseIcon: true,
    onClose: function () { return null; },
};
exports.styles = function (theme) { return ({
    wrapper: {
        border: "1px solid " + theme.pallete.divider,
        boxShadow: theme.shadows.outer['160'],
        borderRadius: theme.radius.modal,
        backgroundColor: theme.pallete.surface.main,
        minWidth: 520,
        pointerEvents: 'auto',
    },
    closeButton: {
        float: 'right',
        marginTop: '0.5rem',
        marginRight: '0.5rem',
    },
}); };
//# sourceMappingURL=ModalContainer.js.map